import { POST } from "../APiHelper/API";

export const refreshLineupsAPICall = (
    data,
    onSuccess,
    onError
) => {

    POST(`/api/v1/games/refresh_lineup`, data, onSuccess, onError);
};
